export const aboutInfo = {
  brandName: '073漫画网',
  slogan: '让阅读漫画成为一种享受',
  foundedYear: 2018,
  introduction: '073漫画网成立于2018年，是国内领先的在线漫画阅读平台之一。我们致力于为广大漫画爱好者提供高品质、正版授权的漫画阅读服务，让每一位读者都能在这里找到属于自己的精彩世界。',
  mission: '073漫画网始终坚持"读者至上"的理念，通过持续优化的阅读体验和丰富的漫画资源，打造国内最受欢迎的漫画阅读社区。我们相信，好的漫画不仅是一种娱乐，更是一种文化传承。',
  values: [
    { title: '品质至上', description: '严格筛选漫画质量，确保每一位读者都能享受到高清画质和精彩剧情。', icon: 'ri-star-line' },
    { title: '读者为先', description: '持续优化阅读体验，下拉式阅读、夜间模式等功能贴心服务每一位读者。', icon: 'ri-user-heart-line' },
    { title: '内容丰富', description: '涵盖玄幻、仙侠、都市、科幻等多种类型，满足不同读者的阅读需求。', icon: 'ri-stack-line' },
    { title: '正版授权', description: '与多家知名漫画平台和作者合作，确保所有内容均为正版授权。', icon: 'ri-shield-check-line' },
  ],
  stats: [
    { label: '注册用户', value: '500万+' },
    { label: '漫画作品', value: '10000+' },
    { label: '累计阅读', value: '100亿+' },
    { label: '日更新量', value: '300+话' },
  ],
  testimonials: [
    {
      name: '漫画爱好者小王',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20simple%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish',
      content: '073漫画网的下拉式阅读真的太方便了！再也不用一页一页翻，直接往下滑就能看完一整话，阅读体验超级流畅。全职法师的更新速度也很快，每天都忍不住来刷！',
      rating: 5,
    },
    {
      name: '资深漫友小李',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%2C%20warm%20smile%2C%20modern%20casual%2C%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish',
      content: '作为一个看了十年漫画的老读者，073漫画网的画质和加载速度都让我非常满意。而且分类很齐全，从热门到小众，总能找到自己喜欢的类型。推荐给所有漫友！',
      rating: 5,
    },
    {
      name: '学生党小张',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20teenager%20portrait%20avatar%2C%20bright%20expression%2C%20student%20vibe%2C%20clean%20simple%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
      content: '每天放学后第一件事就是打开073漫画网看全职法师！免费阅读对我们学生来说太友好了，而且界面简洁没有乱七八糟的广告，爱了爱了。',
      rating: 5,
    },
  ],
  contact: {
    email: 'contact@lninghy.cn',
    wechat: '073comic_official',
    qq: '123456789',
    address: '湖南省长沙市岳麓区麓谷大道073号',
    phone: '0731-8888-8888',
  },
  faqs: [
    {
      question: '073漫画网的内容是否免费？',
      answer: '是的，073漫画网上的所有漫画内容均提供免费在线浏览服务。读者无需付费即可享受高质量的漫画阅读体验。我们通过合法合规的广告运营来维持平台的正常运转。',
    },
    {
      question: '什么是下拉式漫画阅读？',
      answer: '下拉式漫画阅读是一种创新的漫画浏览方式。与传统的翻页阅读不同，读者只需向下滑动屏幕，漫画内容便会自动连续加载，无需频繁点击翻页。这种方式让阅读更加流畅自然，打造沉浸式的阅读体验。',
    },
    {
      question: '全职法师漫画多久更新一次？',
      answer: '全职法师漫画目前保持每周至少更新一次的频率。具体更新时间请关注首页的更新公告，或订阅更新提醒功能，我们会第一时间通知您最新章节的上线。',
    },
    {
      question: '如何搜索我想看的漫画？',
      answer: '您可以通过首页顶部的搜索框输入漫画名称、作者名或关键词来搜索喜欢的漫画。也可以通过分类页面按类型浏览，找到感兴趣的漫画作品。',
    },
    {
      question: '手机可以看漫画吗？',
      answer: '当然可以！073漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。在手机上浏览时，下拉式阅读体验更加自然流畅，随时随地享受阅读乐趣。',
    },
  ],
};